<template>
  <div class="container _container">
    <div class="containerbody">
      <div class="content">
        <div style="font-size: 14px;text-align: left;margin-bottom: 8px">
          <i class="el-icon-s-home"></i>
          <span>
          {{ titleData.title }}>>
            <span @click="subTitleClick(activeIndex)" class="activeIndex" style="cursor: pointer;"
                  v-if="titleData.children!=null">{{ titleData.children[activeIndex].title }}>></span>
              <span style="color: #95c5ff;">{{ this.contentData.title }}</span>
        </span>
        </div>
        <div class="content_left">
          <el-card>
            <div class="sideBar">
              <div class="head_title">{{ titleData.title }}</div>
              <!-- <div >
                  <div class="sub_title">ORGANIZAION</div>
                  <div class="sub_title">STRUCTUR</div>
              </div> -->
              <div class="divide_line"></div>
              <div v-for="(item,index) in titleData.children" :key="index"
                   :class="index == activeIndex?'navActive':'nav'" @click="subTitleClick(index)">{{ item.title }}
              </div>

            </div>
          </el-card>
        </div>
        <div class="content_right">
          <el-card>
            <div class="text_title">
              {{ this.contentData.title }}
            </div>

            <div style="width: 100%;font-size: 16px;line-height: 40px;margin-bottom: 5px;text-align: center">

              <span class="time"
                    style="color: rgba(110, 110, 115, 1);display: inline-block;height: 40px;vertical-align: top;margin-left: 1em">{{ $t('home.time') }}：{{
                  this.contentData.time
                }}</span>
              <span class="author"
                    style="color: rgba(110, 110, 115, 1);display: inline-block;height: 40px;vertical-align: top;margin-left: 1em">{{ $t('home.author') }}：{{
                  this.contentData.author
                }}</span>
              <span class="from"
                    style="color: rgba(110, 110, 115, 1);display: inline-block;height: 40px;vertical-align: top;margin-left: 1em">{{ $t('home.from') }}：{{
                  this.contentData.from
                }}</span>
              <span class="pageView"
                    style="color: rgba(110, 110, 115, 1);display: inline-block;height: 40px;vertical-align: top;margin-left: 1em">{{ $t('home.pageView') }}：{{
                  this.contentData.click
                }}</span>
              <div
                style="color: rgba(110, 110, 115, 1);display: inline-block;height: 40px;vertical-align: top;padding-top: 5px;margin-left: 1em">
                <div class="share"
                     style="width: 80px;height: 30px;display: inline-block;line-height: 30px;margin-left: 5px;vertical-align: top">
                  {{ $t('home.share') }}：
                </div>
                <div v-for="(item,index) in imageList" :key="index" style="display: inline-block;margin-left: 5px">
                  <img :src="item.src" style="width: 20px;height: 20px;display: inline-block;line-height: 20px;cursor: pointer;"
                       @click="shareClick(item)"/>
                </div>
              </div>
            </div>
            <div style="width: 100%;height: 2px;text-align: center">
              <span
                style="width: 90%;height: 1px;background: #cccccc;text-align: center;display: block;margin-left: 5%"></span>
            </div>
            <div class="text_content" v-html="imgTagAddStyle(contentData.content)">


            </div>
            <div class="download" v-if="contentData.fujian!=''&&contentData.fujian!=null&&contentData.fujian!='NULL'">
              相关文件下载：
              <p v-for="(item,index) in contentData.fileList" :key="index">
                <a  :href="item.url" :download="item.name"><i class="el-icon-document"></i> {{item.name}}</a>
              </p>


            </div>
            <div v-if="showPiclist">
              <div v-for="(item,index) in contentData.piclist" :key="index">
                <el-image
                  v-if="item!=''"
                  style="width: 100%; height: auto"
                  :src="item"
                  :preview-src-list="contentData.piclist">
                </el-image>
              </div>


            </div>

            <!-- <div class="share_box">
              <div class="share_img" @click="shareClick">
                <img :src="imageUrl" width="40" height="40"/>
              </div>
              <div class="share_img">
                <img :src="imageUrl2" width="40" height="40"/>
              </div>
            </div> -->
          </el-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {getContentDetail} from '@/api/detail'

export default {
  name: 'aboutUs',
  components: {},
  data() {
    return {
      imageUrl: require('@/components/aboutUs/imgs/facebook.png'),
      imageUrl2: require('@/components/aboutUs/imgs/Twitter.png'),
      imageUrl3: require('@/components/aboutUs/imgs/contentPhoto.png'),
      contentData: {},
      detailId: this.$route.query.detailId,
      pid: this.$route.query.pid,
      id: this.$route.query.id,
      titleData: {},//标题内容
      titleTree: JSON.parse(sessionStorage.getItem('titleTree')),
      activeIndex: 0,
      showPiclist: false,
      imageList: [
        {src: require('@/components/aboutUs/imgs/facebook.png'), url: "https://www.facebook.com/",name:"facebook"},
        {src: require('@/components/aboutUs/imgs/Twitter.png'), url: "http://www.x.com/",name:"twitter"},
        {src: require('@/components/aboutUs/imgs/weibo.jpeg'), url: "http://www.x.com/",name:"weibo"},

      ]

    }
  },
  mounted() {
    this.init()
  },

  methods: {
    init() {
      let that = this;
      getContentDetail({id: this.detailId}).then(res => {
        if (res.data.Img) {
          res.data.Img = res.data.Img.replace(/\/upload/g, `${this.$urlFile}/upload`);
        }
        if (res.data.content) {
          res.data.content = res.data.content.replace(/\/upload/g, `${this.$urlFile}/upload`);
        }
        if (res.data.fujian&&res.data.fujian!='NULL') {
          res.data.fujian = res.data.fujian.replace(/\/upload/g, `${this.$urlFile}/upload`);
          res.data.fileList = JSON.parse(res.data.fujian);
          console.log(res.data.fileList,"***************************")
        }
        if (res.data.piclist != null && res.data.piclist != "" && res.data.piclist != "NULL") {
          res.data.piclist = res.data.piclist.replace(/\/upload/g, `${this.$urlFile}/upload`);
          // 将res.data.piclist按照’|‘进行分割
          res.data.piclist = res.data.piclist.split('|');
          this.showPiclist = true
        }
        this.contentData = res.data
      })

      this.titleTree.children.forEach((item, index) => {
        if (item.data.id == this.pid) {
          this.titleData = item
          // this.queryParams.classId = this.id
          item.children.forEach((item2, index2) => {

            if (item2.data.id == this.id) {

              this.activeIndex = index2
            }
          })
        } else {
          if (item.children != null) {
            item.children.forEach((it, ind) => {
              if (it.data.id == that.pid) {
                that.titleData = it
                it.children.forEach((it2, ind2) => {
                  if (it2.data.id == that.id) {
                    that.activeIndex = ind2
                  }
                })
              }
            })
          }
        }
      });
    },
    // shareClick() {
    //   this.$refs.shareDialog.open('Repost to Facebook', {})

    // },
    subTitleClick(index) {
      if(this.pid == 7||this.pid == 82){
        if(index==0||index==1){
          this.$router.push({
          path: '/cardNavigation',
          query: {
            pid: this.pid,
            id: this.titleData.children[index].data.id,
            // isThirdLevel: true,
          }
        })
        }else{
          this.$router.push({
          path: '/navigation',
          query: {
            pid: this.pid,
            id: this.titleData.children[index].data.id,
            // isThirdLevel: true,
          }
        })
        }
      }else{
        this.$router.push({
        path: '/navigation',
        query: {
          pid: this.pid,
          id: this.titleData.children[index].data.id,
          // isThirdLevel: true,
        }
      })
      }

    },
    imgTagAddStyle(htmlstr) {
      if (htmlstr != "" && htmlstr != null && htmlstr != undefined) {
        let newContent = htmlstr.replace(/<img[^>]*>/gi, function (match, capture) {
          match = match.replace(/style="[^"]+"/gi, '').replace(/style='[^']+'/gi, '')
          match = match.replace(/width="[^"]+"/gi, '').replace(/width='[^']+'/gi, '')
          match = match.replace(/height="[^"]+"/gi, '').replace(/height='[^']+'/gi, '')
          return match
        })
        newContent = newContent.replace(/style="[^"]+"/gi, function (match, capture) {
          match = match.replace(/width:[^;]+;/gi, 'max-width:100%;').replace(/width:[^;]+;/gi, 'max-width:100%;')
          match = match.replace(/font-family:[^;]+;/gi, 'font-family:Arial,\'AKbalthom Freedom Plus\',\'微软雅黑\',SimHei').replace(/font-family:[^;]+;/gi, 'font-family:Arial,\'AKbalthom Freedom Plus\',\'微软雅黑\',SimHei')
          match = match.replace(/font-size:[^;]+;/gi, '').replace(/font-size:[^;]+;/gi, '')
          match = match.replace(/font-size:[^;]+;/gi, '').replace(/font-size:[^;]+;/gi, '')
          match = match.replace(/text-indent:[^;]+;/gi, '')
          return match
        })
        newContent = newContent.replace(/<br[^>]*\/>/gi, '')
        // eslint-disable-next-line no-useless-escape
        newContent = newContent.replace(/\<img/gi, '<img style="max-width:100%;height:auto;margin-left: -2em;display:flex;margin:8px auto;justify-content: center;"')
        newContent = newContent.replace(/&emsp;/gi, '')
        newContent = newContent.replace(/&nbsp;/gi, '')
        return newContent
      }

    },
    shareClick(item){
      if(item.name == "weibo"){
        this.weiboShare()
      }else if(item.name == "facebook"){
        this.facebookShare()
      }else if(item.name == "twitter"){
        this.twitterShare()
      }
      // if(this.$i18n.locale == 'zh'){
      //   // copyToClipboard(text) {
      //     let text = "分享内容："+this.contentData.title +"  链接："+ encodeURIComponent(window.location.href)
      //           try {
      //             navigator.clipboard.writeText(text);
      //             this.$message({
      //                 message: '分享内容已复制到剪贴板,稍等为您跳转',
      //                 type: 'success'
      //               });
      //             setTimeout(() => {
      //               window.open(item.url)
      //             }, 1500);
      //           } catch (err) {
      //           }
      //   }else{
      //     let text = "content："+this.contentData.title +"  link："+ encodeURIComponent(window.location.href)
      //           try {
      //             navigator.clipboard.writeText(text);
      //             this.$message({
      //                 message: 'The shared content has been copied to the clipboard. We will redirect you shortly',
      //                 type: 'success'
      //               });
      //             setTimeout(() => {
      //               window.open(item.url)
      //             }, 1500);
      //           } catch (err) {
      //           }
      //   }
    },
    weiboShare(event){
          // 分享到新浪微博
      // event.preventDefault()
    // shareUrl是微博的分享地址，（有资料说需要真实的appkey，必选参数，这里我没用appkey也可以正常分享）
      var _shareUrl = 'http://service.weibo.com/share/share.php?'
      _shareUrl += 'url=' + encodeURIComponent(window.location.href) //参数url设置分享的内容链接
      _shareUrl += '&title=' + this.contentData.title //参数title设置分享的标题
      // 保留当前页面,打开一个非tab页面（按需求来，可以新开标签页，也可以在当前页新开页面）
      window.open(
        _shareUrl,
        '_blank',

        'scrollbars=yes,resizable=1,modal=false,alwaysRaised=yes'
      )
    },
    twitterShare(){
      let _shareUrl="https://twitter.com/intent/tweet?"
      _shareUrl += 'text=' + this.contentData.title //参数title设置分享的标题
      _shareUrl += '&url=' + encodeURIComponent(window.location.href) //参数url设置分享的内容链接
      _shareUrl += ',sharing'
      // 保留当前页面,打开一个非tab页面（按需求来，可以新开标签页，也可以在当前页新开页面）
      window.open(
        _shareUrl,
        '_blank',
      )
    },
    facebookShare(){
      let _shareUrl="https://www.facebook.com/sharer.php?"
      _shareUrl += 'u=' + encodeURIComponent(window.location.href) //参数url设置分享的内容链接
      // _shareUrl += '&title=' + this.contentData.title //参数title设置分享的标题
      // _shareUrl += ',sharing'
      // 保留当前页面,打开一个非tab页面（按需求来，可以新开标签页，也可以在当前页新开页面）
      window.open(
        _shareUrl,
        '_blank',
      )
    }
  }
}
</script>

<style lang="less" scoped>

// 大于800px
@media only screen and (min-width: 800px) {
  .container {
    width: 100%;
    overflow: hidden;


    .containerbody {
      width: 100%;
      min-height: 55.5vh;
      // max-width:1000px ;
      background-color: rgb(249, 249, 249);
      display: flex;
      flex-direction: column;
      align-items: center;
      padding: 20px 0;

      .content {
        width: 80%;
        margin: 0 auto;

        .content_left {
          width: 16%;
          float: left;

          .sideBar {
            text-align: left;
            width: 100%;

            .head_title {
              padding: 0 0 20px 0;
              color: rgba(51, 51, 51, 1);
              font-family: SourceHanSansCN-Bold;
              font-weight: 700;
              font-size: 18px;
              font-weight: bold;
            }

            .sub_title {
              padding: 4px 0;
              color: rgba(51, 51, 51, 1);
              font-family: SourceHanSansCN-Regular;
              font-size: 12px;

            }

            .divide_line {
              width: 90%;
              height: 1.5px;
              margin: 4px 0;
              background-color: #2D52D0;
            }

            .nav {
              overflow-wrap: break-word;
              color: rgba(110, 110, 115, 1);
              font-size: 12px;
              font-family: SourceHanSansCN-Regular;
              font-weight: normal;
              white-space: nowrap;
              line-height: 24px;
              margin: 15px 0 10px 0;
              overflow: hidden;
              text-overflow: ellipsis;
            }

            .nav:hover {
              overflow-wrap: break-word;
              color: #2D52D0;
              font-size: 12px;
              font-family: SourceHanSansCN-Regular;
              font-weight: normal;
              white-space: nowrap;
              line-height: 24px;
              margin: 15px 0 10px 0;
              cursor: pointer;
              overflow: hidden;
              text-overflow: ellipsis;
            }

            .navActive {
              overflow-wrap: break-word;
              color: #2D52D0;
              font-size: 12px;
              font-family: SourceHanSansCN-Regular;
              font-weight: normal;
              white-space: nowrap;
              line-height: 24px;
              margin: 15px 0 10px 0;
              cursor: pointer;
              overflow: hidden;
              text-overflow: ellipsis;
            }
          }
        }

        .content_right {
          width: 82%;
          float: right;
          // margin-left: 3%;
          .text_title {
            width: 100%;
            padding: 32px 0;
            text-align: center;
            /*font-family: SourceHanSansCN-Bold;!*AKbalthom Freedom Plus*!*/
            font-family: sans-serif, 'AKbalthom Freedom Plus', '微软雅黑', SimHei;
            font-weight: 700;
            color: black;
            font-size: 24px;
            // font-weight: bold;
          }

          .text_content {
            width: 98%;
            padding: 0 1%;
            line-height: 24px;
            text-align: left;
            font-size: 16px;
            font-family: sans-serif, 'AKbalthom Freedom Plus', '微软雅黑', SimHei !important;
            color: black;
            text-indent: 2em;
            margin: 0 auto;
          }

          ::v-deep {
            img {
              width: 100%;
            }
          }

          .text_img {
            width: 100%;
            // padding: 0 0%;
            margin: 20px 0 20px 0;
            // height: 400px;
          }

          .share_box {
            height: 100px;
            float: right;
            margin-top: 50px;

            .share_img {
              float: left;
              margin: 4px;
              cursor: pointer;
            }
          }
        }
      }
    }
  }
}

.activeIndex:hover {
  color: #95c5ff;
}

// 小于800px
@media only screen and (max-width: 800px) {
  .container {
  }


  img,
  [alt],
  img[alt] {
    max-width: 100%;
  }


  .share_img {
    float: left;
    margin: 4px;
    cursor: pointer;
  }
}


// 小于800px
@media only screen and (max-width: 800px) {
  .container {
  }

  .content_left {
    display: none;
  }

  .text_title {
    font-weight: bold;
    font-size: 18px;
  }

  .time {
    font-size: 12px;
  }

  .author {
    font-size: 12px;
  }

  .from {
    font-size: 12px;
  }

  .pageView {
    font-size: 12px;
  }

  .share {
    font-size: 12px !important;
  }
  .text_content {
    width: 98%;
    padding: 0 1%;
    line-height: 24px;
    text-align: left;
    font-size: 14px;
    font-family:Arial,'AKbalthom Freedom Plus','微软雅黑',SimHei!important;
    color: black;
    text-indent: 2em;
    margin: 0 auto;
  }
}


.download{
  text-align: left;
  font-size: 13px;
  margin-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/detail/index.vue